// extracted by mini-css-extract-plugin
export default {"tabClass":"_3ydbCvdztKQyw7aURKZ8pD","tabClassActive":"_1vhqpP37rZKvXBjSayAbaL"};